import { history } from "helpers";

import { approvalModal } from "./modal";
import { getUserStatus } from "service/MyProfile";
import { getPersonalDetailsApi } from "service/MyProfile";

export const userDetail = (data) => {
  return {
    type: "USER_MOBILE_NUMBER",
    payload: data,
  };
};

export const DoctorTypeSet = (payload) => {
  return {
    type: "DOCTER_TYPE",
    payload,
  };
};
export const HideMenu =(payload) => {
  return {
    type: "MENU_HIDE",
    payload,
  };
};
export const restrictionURL =
  (page, isClear, refer) => async (dispatch, getState) => {
    try {
      if (isClear) {
        await dispatch({
          type: "USER_COMPLETED_STEPS",
          payload: {},
        });
        return;
      }
      if (!localStorage.getItem("token")) return;

      const allowedURL = [
        "/profile/consent",
        "/profile/details-preview",
        "/edit-detail/basic-details",
        "/edit-detail/payment-details",
        "/edit-detail/edit-appointment",
        "/edit-detail/education-details",
      ];
      const pathName = window.location.pathname;
      const { data: { data: statusData } = {} } = await getUserStatus();
      console.log(statusData, "dskgsgf");

      // if (!statusData) {
      //   history.push("/");
      //   localStorage.clear();
      //   return;
      // }
      const userCompletedSteps = {
        status: statusData?.status,
        step4: statusData?.isPaymentComplete,
        isAgreed: statusData?.isTermsAndCondition,
        step1: statusData?.isBasicProfileComplete,
        step2: statusData?.isEducationDetailsComplete,
        step3: statusData?.isAppointmentSettingComplete,
      };

      await dispatch({
        type: "USER_COMPLETED_STEPS",
        payload: { ...userCompletedSteps },
      });

      const profileURL = "/profile/basic-details";
      const appointmentURL = "/profile/appointment";
      const paymentURL = "/profile/payment-details";
      const educationURL = "/profile/education-details";

      // if (!userCompletedSteps?.step1) {
      //     if (page === "basic") return; // Avoid Redirect to same page
      //     if (profileURL !== pathName) {
      //         return history.push("/profile/basic-details");
      //     }
      // }

      // if (!userCompletedSteps.step2) {
      //     if (page === "education") return; // Avoid Redirect to same page
      //     if (educationURL !== pathName) {
      //         return history.push("/profile/education-details");
      //     }
      // }

      // if (!userCompletedSteps?.step3) {
      //     if (page === "appointment") return; // Avoid Redirect to same page
      //     if (appointmentURL !== pathName) {
      //         return history.push("/profile/appointment");
      //     }
      // }

      // if (!userCompletedSteps?.step4) {
      //     if (page === "payment") return; // Avoid Redirect to same page
      //     if (paymentURL !== pathName) {
      //         return history.push("/profile/payment-details");
      //     }
      // }

      // if (!userCompletedSteps?.isAgreed) {
      //   if (
      //     !allowedURL.includes(pathName) &&
      //     "/profile/details-preview" !== pathName
      //   ) {
      //     return history.push("/profile/details-preview");
      //   }
      //   return; // Same page
      // }

      const userAllowedURL = [
        paymentURL,
        profileURL,
        educationURL,
        appointmentURL,
        ...allowedURL,
      ];

      if (
        !userCompletedSteps?.step1 ||
        !userCompletedSteps?.step2 ||
        !userCompletedSteps?.step3 ||
        !userCompletedSteps?.step4 ||
        !userCompletedSteps?.isAgreed
      ) {
        if (!userAllowedURL.includes(pathName))
          return history.push("/profile/basic-details");
        return;
      }

      if (["PENDING", "REJECTED"].includes(userCompletedSteps?.status)) {
        if ("/auth/login" !== pathName) {
          localStorage.clear();
          await dispatch(approvalModal(true, userCompletedSteps?.status));
          return history.push("/auth/login");
        }
        await dispatch(approvalModal(true, userCompletedSteps?.status));
        return; // Same page
      }

      if (refer) history.push(refer);

      if (
        [
          ...userAllowedURL,
          "/auth/verify-otp",
          "/auth/login",
          "/auth/sign-up",
        ].includes(pathName)
      ) {
        if ("/doctor/dashboard" !== pathName) {
          return history.push("/doctor/dashboard");
        }
      }

      const { data: { data: personalData } = {} } =
        await getPersonalDetailsApi();

      await dispatch({
        type: "USER_BASIC_DETAILS",
        payload: { ...(personalData ?? {}) },
      });
    } catch (e) {
      console.log(e);
    }
  };
